import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PWAThunk } from 'lib/core/data'
import { Slice, GenerateCustomerTokenPayload } from './types'

export const initialState: Slice = {
  isFetching: false,
  isSuccess: false,
  isFailure: false,
  payload: undefined
}

const slice = createSlice({
  name: 'customer/token',
  initialState,
  reducers: {
    request (state) {
      state.isFetching = true
    },

    success (state, action: PayloadAction<GenerateCustomerTokenPayload>) {
      state.isFetching = false
      state.isSuccess = true
      state.isFailure = false
      state.payload = action.payload
    },

    failure (state, action?: PayloadAction<GenerateCustomerTokenPayload | undefined>) {
      state.isFetching = false
      state.isSuccess = false
      state.isFailure = true
      state.payload = action?.payload ?? initialState.payload
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

interface CustomerTokenDeps {
  email: string
  password: string
  persistent?: boolean
}

export function fetchCustomerToken (payload: CustomerTokenDeps): PWAThunk {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    dispatch(request())

    try {
      const response = await magentoClient.getClient().customer.token({ payload })
      const data = response.data?.generateCustomerToken
      if (data) {
        dispatch(success(data))
      } else {
        dispatch(failure())
      }
    } catch (e) {
      dispatch(failure())
    }
  }
}
